import { Facebook, Instagram, Twitter } from '@news12/storybook-news'

import { FooterField, FooterSectionProps } from '../../../components/FooterSection/FooterSection'

const createFooterOptions = (section: FooterField[]) => {
  const iconMap = {
    Twitter: <Twitter />,
    Facebook: <Facebook />,
    Instagram: <Instagram />
  }
  return section
    .filter(({ name, path }) => name && path)
    .map(({ name, path }) => ({
      name,
      href: path,
      id: name,
      ...(iconMap[name] && { icon: iconMap[name] })
    }))
}

const normalizeFooter = (data: FooterSectionProps['footer']) => {
  return {
    bottomOptions: createFooterOptions(data.about || []),
    topLists: [
      ...Object.keys(data)
        .filter(key => key !== 'about')
        .map(key => ({
          heading: data[key].length
            ? key
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ')
            : '',
          options: createFooterOptions(data[key] || [])
        }))
        .filter(item => item.options.length > 0)
    ]
  }
}

export default normalizeFooter
